import { render, staticRenderFns } from "./ScatterPlot.vue?vue&type=template&id=0f420816&scoped=true"
import script from "./ScatterPlot.vue?vue&type=script&lang=js"
export * from "./ScatterPlot.vue?vue&type=script&lang=js"
import style0 from "./ScatterPlot.vue?vue&type=style&index=0&id=0f420816&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f420816",
  null
  
)

export default component.exports